//адрес токена авторизации в cookie
export const COOKIE_AUTH_TOKEN = process.env.VUE_APP_AUTH_TOKEN;

//api
export const API_CHECK_LIST = process.env.VUE_APP_CHECK_LIST_HOST;
export const API_TENDER = process.env.VUE_APP_TENDER_HOST;
export const API_ORDER = process.env.VUE_APP_ORDER_HOST;
export const API_IMPORT = process.env.VUE_APP_API_IMPORT;

//pages
export const PAGE_LOGIN = process.env.VUE_APP_LOGIN_URL;
export const PAGE_REGISTER = process.env.VUE_APP_REGISTER_URL;
export const PAGE_TARIFFS = process.env.VUE_APP_TARIFFS_URL;
export const PAGE_ORDER = process.env.VUE_APP_ORDER_URL;
export const PAGE_ORDER_LIST = process.env.VUE_APP_ORDER_LIST_URL;
export const PAGE_MONITORING = process.env.VUE_APP_PAGE_MONITORING;
export const PAGE_SEARCH = process.env.VUE_APP_SEARCH_PAGE;
export const PAGE_GOTO_TENDER = process.env.VUE_APP_GOTO_TENDER_URL;
export const PAGE_TENDER = process.env.VUE_APP_TENDER_URL;
export const ROOT_PAGE = process.env.VUE_APP_ROOT_PAGE;

//тестовый токен авторизации, существует только если проект собирается в режиме отладки
export const DEBUG = process.env.NODE_ENV == 'development';
export const DEV_AUTH_TOKEN = process.env.VUE_APP_DEV_TOKEN;

//??
export const FORMS_COOKIE = process.env.VUE_APP_FORMS_COOKIE;
export const USE_CREDENTIALS = process.env.VUE_APP_USE_CREDENTIALS;

//кол-во отображаемых при поиске элементов на странице мониторинга
export const MONITORING_SEARCH_PAGE_COUNT_LIMIT = process.env.VUE_APP_MONITORING_SEARCH_PAGE_COUNT_LIMIT;

// префикс урлов страниц с деталями тендера, плана, субподряда и пр.
export const TENDER_DETAILS_URI_PREFIX = process.env.VUE_APP_TENDER_DETAILS_URI_PREFIX;

export const OPEN_MONITORING_SEARCH_URL_PATH_ENDING = JSON.parse(process.env.VUE_APP_OPEN_MONITORING_SEARCH_URL_PATH_ENDING);

//astral
export const IS_ASTRAL = process.env.VUE_APP_IS_ASTRAL;
